import React from 'react';
import './WhyChooseUs.css';

const items = [
  { icon: '📱', text: 'Mobile & Remote Services' },
  { icon: '🗺️', text: 'Serving All 50 States' },
  { icon: '💰', text: 'Maximum Refund Optimization' },
  { icon: '⚡', text: 'Fast Turnaround (24–48 hrs)' },
  { icon: '🔐', text: 'IRS-Compliant & Secure' },
];

const WhyChooseUs = () => (
  <div className="why-bar">
    <div className="container">
      <div className="why-grid">
        {items.map((item) => (
          <div className="why-item" key={item.text}>
            <div className="why-check">✓</div>
            <span className="why-icon">{item.icon}</span>
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default WhyChooseUs;
